import { render, staticRenderFns } from "./RouteBusStops.vue?vue&type=template&id=64ba0e94&scoped=true&"
import script from "./RouteBusStops.vue?vue&type=script&setup=true&lang=js&"
export * from "./RouteBusStops.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RouteBusStops.vue?vue&type=style&index=0&id=64ba0e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba0e94",
  null
  
)

export default component.exports